export const VR_RESULT_STATUS = {
    UNAVAILABLE: 'unavailable',
    PENDING: 'pending',
    READY: 'ready',
    FAILED: 'failed',
};

export const VR_ERROR_REASONS = {
    UNKNOWN: 'unknown',
    TIMEOUT: 'timeout',
    UNTRANSCRIBABLE: 'untranscribable',
};
